import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import api, { formatErr } from "../../lib/api";
import { Loading, PageHeader, StatusPill } from "../../components/Shared";

const TYPES = ["hospital", "doctor", "diagnostics", "nursing", "attendant", "physiotherapy", "ambulance", "pharmacy", "other"];

export default function Providers() {
  const [providers, setProviders] = useState(null);
  const [form, setForm] = useState({ name: "", type: "hospital", contact: "", city: "Jaipur" });
  const [showForm, setShowForm] = useState(false);
  const load = () => api.get("/admin/providers").then((r) => setProviders(r.data));
  useEffect(() => { load().catch(() => setProviders([])); }, []);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/providers", form); toast.success("Provider added"); setShowForm(false); load(); }
    catch (err) { toast.error(formatErr(err)); }
  };
  const setStatus = async (p, verification_status) => { await api.patch(`/admin/providers/${p.id}`, { verification_status }); toast.success("Updated"); load(); };
  if (!providers) return <Loading />;
  return (
    <div data-testid="admin-providers">
      <PageHeader title="Partner & Provider Directory" sub="Hospitals, doctors, labs, nurses, ambulances and pharmacies. 'Verified' is shown only after verification completes."
        actions={<button onClick={() => setShowForm(!showForm)} className="p1-btn-primary !px-5 !py-2.5" data-testid="add-provider-btn"><Plus className="h-4 w-4" /> Add Provider</button>} />
      {showForm && (
        <form onSubmit={submit} className="p1-card mb-6 grid gap-4 p-5 sm:grid-cols-2" data-testid="provider-form">
          <input className="p1-input" placeholder="Provider name *" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="prov-name" />
          <select className="p1-input" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} data-testid="prov-type">
            {TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
          <input className="p1-input" placeholder="Contact" value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })} data-testid="prov-contact" />
          <div className="sm:col-span-2"><button className="p1-btn-primary !px-5 !py-2.5" data-testid="prov-submit">Save Provider</button></div>
        </form>
      )}
      <div className="grid gap-4 lg:grid-cols-2">
        {providers.map((p) => (
          <div key={p.id} className="p1-card flex items-center justify-between gap-3 p-5" data-testid={`provider-row-${p.id}`}>
            <div>
              <p className="font-heading font-semibold text-stone-900">{p.name}</p>
              <p className="text-xs capitalize text-stone-500">{p.type} · {p.city} · contract: {p.contract_status}</p>
            </div>
            <div className="flex items-center gap-2">
              <StatusPill status={p.verification_status === "in_progress" ? "pending" : p.verification_status} />
              {p.verification_status !== "verified" && (
                <button onClick={() => setStatus(p, "verified")} className="rounded-full bg-emerald-900 px-3 py-1.5 text-xs font-bold text-white" data-testid={`verify-prov-${p.id}`}>Mark verified</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
